/*  MUI  */
import { Box, Paper, Typography } from '@mui/material';

/* Shared */
import { PartnerBackButton } from 'application/Shared/Components/Buttons/BackButton';

/*  React  */
import React from 'react';

/* Helpers */
import ImportantResources from './ImportantResources';
import IntegrationSteps from './Steps';

const IntegrationBody = ({
    deploymentSteps,
    hasToken,
    headerTitle,
    img,
    imgWidth
}) => (
    <Box width="100%" data-testid="integrationWrapperBody">
        <Box data-testid="integrationWrapperBodyImage">
            <img src={img} alt={headerTitle} style={{ width: imgWidth }} />
            <hr />
        </Box>
        <Box mt={2}>
            <Box mb="32px">
                <ImportantResources />
            </Box>
            {hasToken && deploymentSteps?.length > 0 && (
                <IntegrationSteps steps={deploymentSteps} />
            )}
        </Box>
    </Box>
);

export const IntegrationWrapper = ({
    hasToken,
    deploymentSteps,
    headerTitle,
    img,
    imgWidth,
    onboarding
}) =>
    onboarding ? (
        <IntegrationBody
            deploymentSteps={deploymentSteps}
            hasToken={hasToken}
            headerTitle={headerTitle}
            img={img}
            imgWidth={imgWidth}
        />
    ) : (
        <Box data-testid="integrationWrapper">
            <Box width="100%" data-testid="integrationWrapperTitle">
                <Typography variant="h3">{headerTitle}</Typography>
                <hr />
            </Box>
            <PartnerBackButton
                linkTo="/integrations/partnerLevel"
                textOverride="Integrations.Common.back"
            />
            <Paper elevation={0} variant="outlined" style={{ padding: '16px' }}>
                <IntegrationBody
                    deploymentSteps={deploymentSteps}
                    hasToken={hasToken}
                    headerTitle={headerTitle}
                    img={img}
                    imgWidth={imgWidth}
                />
            </Paper>
        </Box>
    );
